<template>
  <div class="detalle-doc">
    <v-expansion-panel popout v-if="solicitud">
      <v-expansion-panel-content v-if="($store.state.user.id_rol === 4 || $store.state.user.id_rol === 3)" :value="true">
        <div slot="header"><strong class="primary--text">Datos del firmante del documento </strong></div>
        <v-card class="pagos">
          <v-card-text>
            <v-text-field
              name="documento_nombre"
              label="Ha sido firmado por:"
              :disabled="$store.state.user.id_rol === 4"
              v-model=solicitud.firmante_documento_nombre
              class="input-group--focused"
            ></v-text-field>
            <v-text-field
              name="documento_cargo"
              label="Quien actúa en calidad de:"
              :disabled="$store.state.user.id_rol === 4"
              v-model=solicitud.firmante_documento_cargo
              class="input-group--focused"
            ></v-text-field>
            <v-text-field
              name="documento_entidad"
              label="Está revestido del sello/timbre"
              :disabled="$store.state.user.id_rol === 4"
              v-model=solicitud.firmante_documento_entidad
              class="input-group--focused"
            ></v-text-field>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content :value="true" v-if="$store.state.user.id_rol === 3">
        <div slot="header"><strong class="primary--text">Departamento donde se enviara el documento para firma</strong></div>
          <v-card class="pagos">
            <v-card-text>
              <v-select
                label="Regional"
                v-model="solicitud.departamento"
                :items="regionales"
              ></v-select>
            </v-card-text>
          </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content :value="true">
        <div slot="header"><strong class="primary--text">Vigencia del documento</strong></div>
        <v-card>
          <v-card-text>
            <h5 class="documento-validez">El documento tiene <strong> {{ Math.abs(Math.floor(( solicitud.fecha_inicio -
              solicitud.fecha_fin ) / 86400000)) }} {{ Math.abs(Math.floor(( solicitud.fecha_fin-solicitud.fecha_inicio
              ) / 86400000)) <= 1 ? 'día' : 'días' }}</strong> de vigencia.</h5>
            <select-date
              model="fecha_inicio"
              :value="solicitud.fecha_inicio"
              v-if="solicitud.fecha_inicio_show"
              :disabled="isDisabled"
              :required="true"
              label="Valido desde el"></select-date>
            <select-date
              model="fecha_fin"
              :value="solicitud.fecha_fin"
              v-if="solicitud.fecha_fin_show"
              :disabled="isDisabled"
              :required="true"
              label="Hasta el"></select-date>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content :value="true">
        <div slot="header"><strong class="primary--text">Datos del documento</strong></div>
        <v-card>
          <v-card-text>
            <h4 class="margin-0">{{ solicitud.documento_nombre }}
              <!--<small v-for="item in solicitud.documento_monto">(Costo: {{ item.monto }} Bs.)</small>-->
            </h4>
            <p>
              {{ solicitud.documento_descripcion }} <br>
              <strong>{{ solicitud.documento_entidad_nombre }}</strong>
            </p>
            <v-alert color="warning" value="true" v-if="solicitud.observacion">
              <strong>Observación.-</strong> {{ solicitud.observacion }}
            </v-alert>
            <strong>Número de apostilla:</strong> {{ solicitud.nro_apostilla || 'Pendiente' }} <br>
            <strong>Código de seguridad:</strong> {{ solicitud.cod_seguridad || 'Pendiente' }} <br>
            <strong>Fecha de expedición:</strong> {{ $datetime.format(solicitud.fecha_expedicion) || 'Pendiente' }}
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content>
        <div slot="header"><strong class="primary--text">Datos del solicitante</strong></div>
        <v-card>
          <v-card-text>
            <strong>Nombre completo:</strong> {{ solicitud.tramite_solicitante_nombres }} {{
            solicitud.tramite_solicitante_primer_apellido }} {{ solicitud.tramite_solicitante_segundo_apellido }} <br>
            <strong>{{ solicitud.tramite_solicitante_tipo_documento }}:</strong> {{
            solicitud.tramite_solicitante_nro_documento }} <br>
            <strong>Fecha de nacimiento:</strong> {{ formato_fecha(solicitud.tramite_solicitante_fecha_nacimiento) }} <br>
            <strong>Email:</strong> {{ solicitud.tramite_solicitante_email }} <br>
            <strong>Teléfono:</strong> {{ solicitud.tramite_solicitante_telefono }}
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content>
        <div slot="header"><strong class="primary--text">Datos de la solicitud</strong></div>
        <v-card>
          <v-card-text>
            <strong>Código de seguimiento:</strong> {{ solicitud.tramite_cod_seguimiento }} <br>
            <strong>Fecha de solicitud:</strong> {{ $datetime.format(solicitud.tramite_fecha_inicio) }} <br>
            <strong>Fecha de culminación:</strong> {{ $datetime.format(solicitud.tramite_fecha_fin) || 'Pendiente' }}<br>
            <strong>Tipo de apostilla: </strong> <span v-if="solicitud.digital">Digital</span> <span v-else>Física</span><br>
            <strong>Departamento: </strong> {{solicitud.departamento}}<br>
            <span v-for="(value, key) in solicitud.otros">
              <strong v-if="value.nombre">{{value.nombre}}: </strong><span v-if="value.value">{{value.value}}</span><br>
            </span>

          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content>
        <div slot="header"><strong class="primary--text">Pagos</strong></div>
        <v-card class="pagos">
          <template v-for="(item, index) in pagos">
            <v-card-text>
              <h5 class="primary--text">
                <v-icon color="primary">monetization_on</v-icon>
                PAGO {{ item.tipo }}
              </h5>
              <strong>CPT:</strong> <span v-if="item.cpt">{{item.cpt.cpt}}</span> <span v-else>Pendiente de generarse</span> <br>
              <strong>Fecha de pago:</strong> {{ $datetime.format(item.fecha_pago) || 'Pendiente' }} <br>
              <strong>Estado:</strong> {{ item.estado }} <br>
              <strong>Titular del pago:</strong> {{ item.titular_factura }} -
              <strong>{{ item.tipo_documento }}:</strong> {{ item.nro_documento }}
            </v-card-text>
            <v-divider v-if="index + 1 < pagos.length"></v-divider>
          </template>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import tramiteDoc from './mixins/tramite_doc';
import SelectDate from '@/common/util/SelectDate';
import moment from 'moment';

const regionales = [
  'LA PAZ',
  'COCHABAMBA',
  'SANTA CRUZ'
];

export default {
  mixins: [ tramiteDoc ],
  components: {
    SelectDate
  },
  data () {
    return {
      menu: false,
      menu2: false,
      regionales,
      regional: ''
    };
  },
  props: {
    solicitud: {
      type: Object,
      default: null
    },
    pagos: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isDisabled () {
      // this.solicitud.documento_derivar === 'ENTIDAD'
      return this.$store.state.user.id_rol === 3 || this.$store.state.user.id_rol === 4 || (this.solicitud && (this.solicitud.estado === 'REVISADO_CANCILLERIA'));
    }
  },
  methods: {
    formato_fecha (value) {
      return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
  }
};
</script>

<style lang="scss">
  .detalle-doc {
    padding: 0 20px 0 0;

    .pagos {
      .divider {
        margin-top: 0;
      }
    }

    .card__text {
      padding-top: 0;
    }

    .expansion-panel__container.expansion-panel__container--active {
      margin-top: 0;
    }
  }
  .documento-validez {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// DetalleDoc.vue?038f82fc